const scrapeSeed = [
  {
    type: 'FacebookGroup',
    listItem: 'div[data-visualcompletion="ignore-dynamic"][role="listitem"]',
    image: 'g > image',
    name:
      'div[data-visualcompletion="ignore-dynamic"][role="listitem"] >div >div> div:nth-child(2) a:nth-child(1)',
    link:
      'div[data-visualcompletion="ignore-dynamic"][role="listitem"] >div >div> div:nth-child(2) a:nth-child(1)',
    others:
      'div[data-visualcompletion="ignore-dynamic"][role="listitem"] >div >div> div:nth-child(2) > div >div >div >div:last-child >span',
    imgAttribute: 'xlink:href',
    platform: 'Facebook',
  },
  {
    type: 'InstagramFollowerFollowing',
    listItem: '.x1dm5mii.x16mil14.xiojian.x1yutycm.x1lliihq.x193iq5w.xh8yej3',
    image: 'img[src]',
    name: '.x1rg5ohu >a span',
    link: '.x1rg5ohu >a',
    others: '',
    imgAttribute: 'src',
    platform: 'Instagram',
  },
  {
    type: 'InstagramFollowerFollowing2', //followers
    listItem: 'li._aaei ',
    image: 'li._aaei img._aa8j',
    name: 'li._aaei a.oajrlxb2.g5ia77u1.qu0x051f.esr5mh6w.e9989ue4 > span',
    link: 'li._aaei a.oajrlxb2.g5ia77u1.qu0x051f.esr5mh6w.e9989ue4',
    others: '_aaeq',
    imgAttribute: 'src',
    platform: 'Instagram',
  },
  {
    type: 'InstagramSearch',
    listItem: 'a.-qQT3',
    image: 'img._6q-tv',
    name: '._7UhW9.xLCgt.qyrsm.KV-D4.uL8Hv',
    link: 'a.-qQT3',
    others: 'span.Fy4o8',
    imgAttribute: 'src',
    platform: 'Instagram',
  },

  {
    type: 'FacebookFriend',
    listItem:
      '.x6s0dn4.x1lq5wgf.xgqcy7u.x30kzoy.x9jhf4c.x1olyfxc.x9f619.x78zum5.x1e56ztr.xyamay9.x1pi30zi.x1l90r2v.x1swvt13.x1gefphp',
    image:
      '.x6s0dn4.x1lq5wgf.xgqcy7u.x30kzoy.x9jhf4c.x1olyfxc.x9f619.x78zum5.x1e56ztr.xyamay9.x1pi30zi.x1l90r2v.x1swvt13.x1gefphp a > img',
    name:
      '.x6s0dn4.x1lq5wgf.xgqcy7u.x30kzoy.x9jhf4c.x1olyfxc.x9f619.x78zum5.x1e56ztr.xyamay9.x1pi30zi.x1l90r2v.x1swvt13.x1gefphp > div:nth-child(2) >div:first-child >a >span',
    link:
      '.x6s0dn4.x1lq5wgf.xgqcy7u.x30kzoy.x9jhf4c.x1olyfxc.x9f619.x78zum5.x1e56ztr.xyamay9.x1pi30zi.x1l90r2v.x1swvt13.x1gefphp > div:nth-child(2) >div:first-child >a',
    others:
      '.x6s0dn4.x1lq5wgf.xgqcy7u.x30kzoy.x9jhf4c.x1olyfxc.x9f619.x78zum5.x1e56ztr.xyamay9.x1pi30zi.x1l90r2v.x1swvt13.x1gefphp .x1gslohp',
    imgAttribute: 'src',
    platform: 'Facebook',
  },

  {
    type: 'FacebookSearchPeople',
    listItem: '.x1yztbdb',
    image: 'image',
    name: 'a[role="presentation"][href]',
    link: 'a[role="presentation"]',
    others:
      '[aria-label="Search results"] div[role="feed"] div[role="article"] div[data-visualcompletion="ignore-dynamic"]> div >div >div:nth-child(2) > div >div > div >div:nth-child(2) >span >span',
    imgAttribute: 'xlink:href',
    platform: 'Facebook',
  },

  {
    type: 'FacebookSearch',
    listItem: '[data-visualcompletion="ignore-dynamic"] >div> div',
    image: 'g > image',
    name: 'a[role="presentation"][href]',
    link: 'a[role="presentation"][href]',
    muturalFriend: '.pvreidsc > span',
    others: '.jroqu855.nthtkgg5 span.b6ax4al1.lq84ybu9.hf30pyar.om3e55n1',
    imgAttribute: 'xlink:href',
    platform: 'Facebook',
  },
];

export default scrapeSeed;
